const AVATAR_GRADIENTS = [
  'linear-gradient(135deg, var(--indigo), var(--violet))',
  'linear-gradient(135deg, var(--violet), var(--cyan))',
  'linear-gradient(135deg, var(--cyan), var(--green))',
] as const

export function getAvatarGradient(name: string): string {
  let hash = 0
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash)
  }
  return AVATAR_GRADIENTS[Math.abs(hash) % AVATAR_GRADIENTS.length]
}

export const PIPELINE_STAGES: string[] = [
  'sourcing',
  'building',
  'matching',
  'applying',
  'placed',
]

const STAGE_LABELS: readonly string[] = ['소스', '이력서', '매칭', '자소서', '완료']

export function getStageIndex(stage: string): number {
  return PIPELINE_STAGES.indexOf(stage)
}

export function getStageLabel(index: number): string {
  if (index < 0 || index >= STAGE_LABELS.length) return ''
  return STAGE_LABELS[index]
}

const TIER_LABELS: readonly string[] = ['도전', '안정', '안정+']

export function getTierLabel(tier: number): string {
  if (tier < 1 || tier > TIER_LABELS.length) return ''
  return TIER_LABELS[tier - 1]
}

const TIER_COLORS: readonly string[] = [
  'var(--red)',
  'var(--amber)',
  'var(--green)',
]

export function getTierColor(tier: number): string {
  if (tier < 1 || tier > TIER_COLORS.length) return 'var(--text-tertiary)'
  return TIER_COLORS[tier - 1]
}

export function predictSuccessRate(
  matchScore: number | null,
  stage: string,
): number {
  if (matchScore == null) return 0
  let multiplier = 0
  if (stage === 'matching') multiplier = 0.8
  else if (stage === 'placed') multiplier = 0.4
  else if (stage === 'sourcing') multiplier = 0.2
  return Math.max(0, Math.round(matchScore * multiplier))
}

export function formatPercent(n: number): string {
  return `${Math.round(n)}%`
}
